<template>
    <div>
        <h3 class="greenTitle">Buscar LPN's no terminales por ruta, SOC o LPN.</h3>
        <el-row>
            <el-col :sm="24" :md="16" :lg="14">
                <div v-if="!searchingRoute">
                    <el-radio-group
                        v-model="searchType"
                        class="mb-1"
                        @change="clearSearchInput">
                        <el-radio-button label="route">Ruta</el-radio-button>
                        <el-radio-button label="soc">SOC</el-radio-button>
                        <el-radio-button label="lpn">LPN</el-radio-button>
                    </el-radio-group>

                    <el-input
                        v-if="searchType === 'route'"
                        @change="changeFindRoute"
                        placeholder="Ruta Ejemplo: 11549"
                        prefix-icon="el-icon-user"
                        v-model="routeId"
                        maxlength="20"
                        show-word-limit
                        type="number"
                        ref="inputFindRoute">
                        <el-button
                            slot="append"
                            icon="el-icon-check"
                            style="color: #AAD500;"
                            @click="clickButton()">
                            BUSCAR
                        </el-button>
                    </el-input>

                    <el-input
                        v-if="searchType !== 'route'"
                        v-model="searchText"
                        type="textarea"
                        :rows="6"
                        resize="none"
                        :placeholder="searchPlaceholder"
                        ref="inputFindRoute">
                    </el-input>

                    <el-button
                        v-if="searchType !== 'route'"
                        class="default mt-1"
                        icon="el-icon-check"
                        :disabled="!hasSearchInput"
                        @click="clickButton()">
                        BUSCAR
                    </el-button>
                </div>

                <p v-else style="font-size: 14px; color: #A0BE03">
                          <i class="el-icon-loading" style="margin-right: 5px;">
                          </i>BUSCANDO LA RUTA Y SUS ORDENES
                </p>

            </el-col>
        </el-row>
    </div>
</template>

<script>

import { apiRequest } from '@/backend/vue-axios/axios';


export default {
  name: 'findRoute',
  components: {
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    this.$refs.inputFindRoute.focus();
  },
  data() {
    return {
      searchType: 'route',
      routeId: '',
      searchText: '',
      route: {
        id: 0,
        enterprise_name: '',
        driver_name: '',
        orders: [],

      },
      searchingRoute: false,
    };
  },
  computed: {
    searchPlaceholder() {
      if (this.searchType === 'soc') {
        return 'Una o varias SOC separadas por salto de linea, coma o espacio';
      }
      return 'Uno o varios LPN separados por salto de linea, coma o espacio';
    },
    hasSearchInput() {
      if (this.searchType === 'route') {
        return parseInt(this.routeId, 10) > 0;
      }
      return this.parseTextList(this.searchText).length > 0;
    },
  },
  methods: {
    parseTextList(value) {
      return value
        .split(/[\s,;]+/)
        .map(item => item.trim())
        .filter(item => item !== '')
        .filter((item, index, list) => list.indexOf(item) === index);
    },
    parseNumericList(value) {
      return this.parseTextList(value)
        .map(item => Number(item))
        .filter(item => Number.isInteger(item) && item > 0)
        .filter((item, index, list) => list.indexOf(item) === index);
    },
    clearSearchInput() {
      this.routeId = '';
      this.searchText = '';
      this.$nextTick(() => {
        if (this.$refs.inputFindRoute) this.$refs.inputFindRoute.focus();
      });
    },
    buildSearchParams() {
      if (this.searchType === 'route') {
        return {
          search_type: 'route',
          route_id: parseInt(this.routeId, 10),
        };
      }
      if (this.searchType === 'soc') {
        return {
          search_type: 'soc',
          suborders: this.parseNumericList(this.searchText),
        };
      }
      return {
        search_type: 'lpn',
        lpns: this.parseTextList(this.searchText),
      };
    },
    clickButton() {
      if (!this.hasSearchInput) {
        this.$notify({
          type: 'warning',
          title: 'Advertencia',
          message: 'Ingresa un valor de busqueda valido.',
        });
        return;
      }
      this.searchingRoute = true;

      apiRequest(
        {
          module: 'planning',
          service: 'search_state_orders',
          params: this.buildSearchParams(),
        },
      ).then((response) => {
        const { data } = response;
        const orders = data.orders.map(order => ({
          ...order,
          action: '',
        }));

        this.route = {
          id: data.id,
          enterprise_name: data.enterprise_name,
          driver_name: data.driver_identification,
          plate: data.patent,
          validation_warnings: data.validation_warnings || [],
          orders,
        };
        this.searchingRoute = false;
        this.$emit('routeFound', this.route);
      }).catch((error) => {
        this.searchingRoute = false;
        this.$notify({
          type: 'info',
          title: 'Información',
          message: error.response.data.message,
        });

        this.$refs.inputFindRoute.focus();
      });
    },
    changeFindRoute() {
      this.clickButton();
    },
  },
};
</script>

<style>
.greenTitle {
    font-size: 15px;
    color: #AAD500;
    margin: 0;
    text-align: left;
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
